module.exports = __webpack_public_path__ + "img/12_klio_26.0430058a.jpg";